import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I think I finally understand what a neural network is",
  "description": "",
  "published": "2011-11-09T00:00:00.000Z",
  "redirect_from": ["/blog/i-think-i-finally-understand-what-a-neural-network-is/swizec/2891"],
  "categories": "Artificial intelligence, Artificial neural network, Learning, Neural network, People, Stanford, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I was consumed with watching lessons from the `}<a parentName="p" {...{
        "href": "http://ml-class.org"
      }}>{`online machine learning class at Stanford`}</a>{`. The topic was `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Neural_network",
        "title": "Neural network"
      }}>{`neural networks`}</a>{`, or rather the finer points of forward and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Backpropagation",
        "title": "Backpropagation"
      }}>{`back propagation`}</a>{`.`}</p>
    <p>{`Every time I have wanted to learn how neural networks work it just didn't click. Anyone I asked mostly just waved their hands and said that something magical happens and ... but let's start at the beginning.`}</p>
    <p>{`The basics of neural networks is that you have neurons that are connected to other neurons. At one end you enter your input data and on the other end the neural network produces some numbers according to what it has learned. Everyone can imagine this much and it's not really difficult to visualise.`}</p>
    <p>{`It looks like a bunch of circles with arrows:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/300px-Neural_network_example.svg_14.png",
        "alt": "Simple neural network, Italian nouns",
        "title": "Simple neural network, Italian nouns"
      }}></img></p>
    <p>{`Anyone who's studied this a tad further can tell you the connections between neurons are very important and the weights associated with them are somehow used in calculating stuff. Not a hard concept to grasp - every neuron outputs a number that is multiplied with the weight on each connection before being fed as an input into the next neuron.`}</p>
    <p>{`Where it always got a bit hairy for me was trying to understand `}<em parentName="p">{`what do the neurons do?`}</em>{` The most I could get out of anyone supposedly knowing this stuff is that "it calcualtes stuff". Yes but `}<em parentName="p">{`how? What`}</em>{` does it do? What exactly?`}</p>
    <p>{`Nobody knew.`}</p>
    <p>{`Last night I finally figured it out! Neurons don't do anything. They don't even exist per se. In fact a neural network looks pretty damn odd inside a computer, it's really just a matrix of weights.`}</p>
    <p>{`What happens when you're doing forward propagation (using a learned network) is simply this:`}</p>
    <ol>
      <li parentName="ol">{`Take the outputs from the previous layer (a vector of numbers)`}</li>
      <li parentName="ol">{`Multiply with a vector of weights (the arrows)`}</li>
      <li parentName="ol">{`Apply the cost function (this becomes the new layer)`}</li>
    </ol>
    <p>{`Then you just repeat this for all the layers and that's that. That is literally all that happens.`}</p>
    <p>{`In the end you are left with a vector of numbers representing the output layer, which you then just have to correctly interpret.`}</p>
    <p>{`The part I don't have completely figured out yet is the backpropagation. This is the bit where neural networks learn how to do their magic. Basically backpropagations sets those weights from step 2 via a simple `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hill_climbing",
        "title": "Hill climbing"
      }}>{`hill climbing algorithm`}</a>{` ... it is essentially a way to calculate the gradient of the cost function so that you can correctly change the weights to achieve ever lower differences between what you're supposed to know and what you actually know. Eventually you hope to achieve a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Maxima_and_minima",
        "title": "Maxima and minima"
      }}>{`global minimum`}</a>{`, but you are guaranteed to at least achieve a local minimum and not being able to tell whether it's global.`}</p>
    <p>{`That's it. That is really all there is to it. Neural networks are just a nice way to visualise a sequence of matrix multiplications. And I guess it's easier to get grants for "neural networks" than "sequence of matrix multiplications" ...`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.citeulike.org/user/fbaroni/article/7490581"
        }}>{`Tradeoffs and constraints on neural representation in networks of cortical neurons.`}</a>{` (citeulike.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://vql89.wordpress.com/2011/10/26/training-of-neural-network/"
        }}>{`Training of Neural Network`}</a>{` (vql89.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://joeyjardins.wordpress.com/2011/10/22/unique-neural-networks-make-leo-trader-pro-a-unique-and-profitable-forex-trading-system/"
        }}>{`Unique Neural Networks Make Leo Trader Pro A Unique And Profitable Forex Trading System`}</a>{` (joeyjardins.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.scientificamerican.com/article.cfm?id=artificial-intelligence-finds-fossil-sites"
        }}>{`Artificial Intelligence Finds Fossil Sites`}</a>{` (scientificamerican.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=397dbc03-6870-445d-952c-b5c6dd95749a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      